import 'react';
import PropTypes from 'prop-types';

const propsValidation = {
  breadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  coverSection: PropTypes.shape({
    image: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  }),
  destination: PropTypes.object,
  isPagination: PropTypes.bool,
  links: PropTypes.shape(),
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          url: PropTypes.string,
        })
      ),
      title: PropTypes.string,
    })
  ),
  modules: PropTypes.array,
  numberOfPages: PropTypes.number,
  pageNumber: PropTypes.number,
  submenu: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        href: PropTypes.string,
        name: PropTypes.string,
        type: PropTypes.string,
        visible: PropTypes.bool,
      })
    ),
    selected: PropTypes.string,
  }),
};

export default propsValidation;
